module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "config-management"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Config Management")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Kelola Konfigurasi Aplikasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Konfig Aplikasi\n          ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped"
  }, _vm._l((_vm.configs), function(config, index) {
    return _c('tr', {
      key: config.id
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(config.key))])]), _vm._v(" "), _c('td', [(_vm.editRow == index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editValue),
        expression: "editValue"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.editValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editValue = $event.target.value
        }
      }
    }) : _c('span', [_vm._v(_vm._s(config.value))])]), _vm._v(" "), _c('td', [(_vm.editRow != index) ? _c('span', {
      staticClass: "btn btn-primary btn-xs"
    }, [_c('i', {
      staticClass: "fa fa-edit",
      on: {
        "click": function($event) {
          return _vm.edit(index)
        }
      }
    })]) : _c('div', [_c('span', {
      staticClass: "btn btn-success btn-xs"
    }, [_c('i', {
      staticClass: "fa fa-check",
      on: {
        "click": function($event) {
          return _vm.confirm(index)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "btn btn-danger btn-xs"
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          _vm.editRow = -1
        }
      }
    })])])])])
  }), 0)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Perhatian!")]), _vm._v(" Jangan lupa mengklik tombol \"Simpan\" untuk menyimpan perubahan konfig ke server")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7632a5ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config_management/Form.vue
// module id = 1369
// module chunks = 0